/**
 * Shared video URL parsing for Navimow theme (YouTube, Vimeo, embed URLs).
 */
(function (global) {
    if (global.NavimowVideoUrl) return;
  
    var YOUTUBE_ID_RE =
      /^.*(?:youtu\.be\/|shorts\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    var YOUTUBE_STRICT_RE =
      /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|shorts\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
    var VIMEO_ID_RE =
      /vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|album\/(\d+)\/video\/|)(\d+)(?:$|\/|\?)/;
  
    function normalizeCcLang(locale) {
      var lang = (locale || 'en').toString();
      return lang === 'nb' ? 'no' : lang;
    }
  
    function getYouTubeId(url, options) {
      options = options || {};
      if (!url) return null;
  
      var str = String(url);
      var match = str.match(YOUTUBE_ID_RE);
      var id = match && match[1] ? match[1] : null;
  
      if (!id) {
        var strict = str.match(YOUTUBE_STRICT_RE);
        id = strict ? strict[1] : null;
      }
  
      if (id && options.requireElevenChars && id.length !== 11) return null;
      return id;
    }
  
    function getVimeoId(url) {
      if (!url) return null;
      var match = String(url).match(VIMEO_ID_RE);
      return match ? match[3] : null;
    }
  
    function isYouTubeUrl(url) {
      return /youtube\.com|youtu\.be/i.test(url || '');
    }
  
    function isVimeoUrl(url) {
      return /vimeo\.com/i.test(url || '');
    }
  
    function toYouTubeEmbedUrl(videoId, options) {
      options = options || {};
      var ccLang = normalizeCcLang(options.locale || options.ccLang);
      return (
        'https://www.youtube.com/embed/' +
        videoId +
        '?autoplay=1&cc_load_policy=1&cc_lang_pref=' +
        encodeURIComponent(ccLang)
      );
    }
  
    function toVimeoEmbedUrl(videoId, options) {
      options = options || {};
      var ccLang = options.ccLang;
      if (ccLang == null && typeof localStorage !== 'undefined') {
        ccLang =
          localStorage.getItem('sel-autodetect-lang') ||
          options.locale ||
          'en';
      }
      ccLang = normalizeCcLang(ccLang || options.locale || 'en');
      return (
        'https://player.vimeo.com/video/' +
        videoId +
        '?autoplay=1&cc_load_policy=1&cc_lang_pref=' +
        encodeURIComponent(ccLang)
      );
    }
  
    /**
     * @param {string} url
     * @param {{ locale?: string, ccLang?: string, requireElevenChars?: boolean }} [options]
     * @returns {{ type: 'youtube'|'vimeo'|'native', videoId: string|null, embedUrl: string }|null}
     */
    function toEmbedUrl(url, options) {
      if (!url) return null;
      options = options || {};
  
      if (isYouTubeUrl(url)) {
        var ytId = getYouTubeId(url, options);
        if (!ytId) return null;
        return {
          type: 'youtube',
          videoId: ytId,
          embedUrl: toYouTubeEmbedUrl(ytId, options),
        };
      }
  
      if (isVimeoUrl(url)) {
        var vimeoId = getVimeoId(url);
        if (!vimeoId) return null;
        return {
          type: 'vimeo',
          videoId: vimeoId,
          embedUrl: toVimeoEmbedUrl(vimeoId, options),
        };
      }
  
      return { type: 'native', videoId: null, embedUrl: String(url) };
    }
  
    function getNavimowVideoUrl() {
      return global.NavimowVideoUrl || null;
    }
  
    global.NavimowVideoUrl = {
      normalizeCcLang: normalizeCcLang,
      getYouTubeId: getYouTubeId,
      getVimeoId: getVimeoId,
      isYouTubeUrl: isYouTubeUrl,
      isVimeoUrl: isVimeoUrl,
      toYouTubeEmbedUrl: toYouTubeEmbedUrl,
      toVimeoEmbedUrl: toVimeoEmbedUrl,
      toEmbedUrl: toEmbedUrl,
    };
    global.getNavimowVideoUrl = getNavimowVideoUrl;
  })(typeof window !== 'undefined' ? window : this);
  